module.exports = __webpack_public_path__ + "static/media/message-group.f9b3df3a.svg";